import {
  Drawer,
  Hidden,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,

} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

import classNames from "classnames";
import React from "react";
import { withTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { getNavItems } from "../../../services/navService";
import { ChevronLeftTwoTone } from "@mui/icons-material";
import MatIcon from "../../common/matIcon";

class NavBar extends React.Component {
  constructor() {
    super();
    this.state = {};
    this.nav = getNavItems();
  }

  push = (subapp) => {
    window.history.pushState(null, subapp, subapp);
  };

  handleClick = (e) => {
    this.setState({ [e]: !this.state[e] });
    const { selected } = this.state;
    if (selected === e)
      this.setState({ selected: null })
    else
      this.setState({ selected: e })

  };

  componentDidMount() {
    const { org } = this.props;
    org.then(orgData => {
      this.setState({ org: orgData })
    })
  }

  drawer(onDrawerClick) {
    const { classes, open, t } = this.props;
    const { org } = this.state;

    return <>
      <div className={classes.toolbarIcon}>
        {/* {open && */}
          <a href="https://www.syniza.in" target="_blank" style={{display:"flex",flexDirection:"column",alignContent:"center", alignItems:"center",width:"100%"}}>

            <img src="../../../logo.jpeg" width={100} height={60} />
          </a>
        {/* } */}
        {/* <img src="../../../logo1.png" style={{ height: "40px" }} /> */}
        {/* <img src="/logo.png" style={{ height: "40px" }} />*/}
        {/* <img src="../../../logo.jpeg" width={100} height={60} /> */}

        {/* <h2 style={{
          textAlign: "center",
          width: "100%",
          marginLeft: "12px"
        }}>
          AccrEdu
        </h2>  */}
        {/* <IconButton onClick={onDrawerClick}>
          <ChevronLeftTwoTone />
        </IconButton> */}
      </div>
      <Divider />

      {this.nav.groups.map((navGroup) => {
        return (
          <>
            {/* <div id="org-logo" style={{ paddingTop: "5%", height: "90px", borderBottom: "1px solid #7e7c7c" }}>
              {org && <img alt={org?.nickName} src={"data:" + org?.logoContentType + ";base64," + org?.logo} style={{
                margin: "auto",
                height: "90px",
                width: "100%",
              }}
              />}
              <Divider />
            </div> */}
            <List
              key={navGroup.id} style={{ marginTop: "20px" }}
            >
              {navGroup.items.map((item) => {
                return (
                  <div key={item.id}>
                    {item.subitems != null ? (
                      <div key={item.id}>
                        <ListItemButton
                          button
                          key={item.id}
                          color="grey"
                          onClick={() => this.handleClick(item.id)}
                          className={classNames((item.id === this.state.selected && classes.navMainActive),classes.customNavbar)}
                        >
                          <Tooltip title={t(item.name)} placement="top">
                            <ListItemIcon className={classes.listItemIcon}>
                              <Icon color="grey" baseClassName="material-icons-two-tone">{item.icon}</Icon>
                            </ListItemIcon>
                          </Tooltip>
                          <ListItemText primary={t(item.name)} />

                          {item.id === this.state.selected ? (
                            <Icon baseClassName="material-icons-two-tone">{'expand_more'}</Icon>
                          ) : (
                            <Icon baseClassName="material-icons-two-tone">{'expand_less'}</Icon>

                          )}
                        </ListItemButton>

                        <Collapse
                          key={navGroup.items.id}
                          component="li"
                          in={item.id === this.state.selected}
                          timeout="auto"
                          unmountOnExit
                        >
                          <List disablePadding>
                            {item.subitems.map((sitem) => {
                              return (
                                <ListItemButton
                                  button
                                  key={item.id + "-" + sitem.id}
                                  className={classNames(classes.nested,classes.customNavbar)}
                                  component={NavLink}
                                  to={sitem.url}
                                  activeClassName={classes.navActive}
                                  style={{width:"215px"}}
                                >
                                  <ListItemIcon
                                    className={classes.listItemIcon}
                                  >
                                    <Icon style={{fontSize:"10px"}} baseClassName="material-icons-two-tone" fontSize="10px">{"circle"}</Icon>
                                  </ListItemIcon>
                                  <Hidden smDown implementation="css">

                                    <ListItemText
                                      key={item.id + "-" + sitem.id}
                                      primary={t(sitem.name)}
                                      class="sub-items"
                                      style={{marginLeft:"-15px"}}

                                    />
                                  </Hidden>
                                  <Hidden smUp implementation="css">

                                    <ListItemText
                                      key={item.id + "-" + sitem.id}
                                      primary={t(sitem.name)}
                                      onClick={onDrawerClick}
                                    />
                                  </Hidden>
                                </ListItemButton>
                              );
                            })}
                          </List>
                        </Collapse>
                      </div>
                    ) : (
                      <>
                        <ListItemButton
                          button
                          key={item.id}
                          component={NavLink}
                          to={item.url}
                          activeClassName={classes.navActive}
                          className={classNames(classes.customNavbar)}
                          // color="grey"
                          
                        >
                          <ListItemIcon

                            className={classes.listItemIcon}
                            title={t(item.name)}
                            // color="primary"
                          >
                            <MatIcon name={item.icon}  />
                            {/* <Icon baseClassName="material-icons-two-tone">{item.icon}</Icon> */}
                          </ListItemIcon>
                         <ListItemText style={{ textWrap: "nowrap" }} primary={t(item.name)} sx={{ display: { xs: 'none', md: 'block' } }} />
                        
                          <ListItemText primary={t(item.name)} onClick={onDrawerClick} sx={{ display: { md: 'none', xs: 'block' } }} />
                        </ListItemButton>
                      </>
                    )}
                  </div>
                );
              })}

            </List>

           
          </>
        );
      })}
    </>;

  }

  render() {
    const { classes, mobileOpen, open, onDrawerClick, onMobileDrawerClick } = this.props;
    //console.log("open:",open);
    const { org } = this.state;
    return <><Hidden mdDown implementation="css">
      <Drawer
        id="drawer-left-temporary"
        variant="permanent"
        classes={{
          paper: classNames(
            open ? classes.drawerPaper : classes.drawerPaperClose
          ),
        }}
        open={open}
      >
        {this.drawer(onDrawerClick)}
      </Drawer>
    </Hidden>
      <Hidden mdUp implementation="css">
        <Drawer
          id="drawer-left"
          variant="temporary"
          classes={{
            paper:
              classes.drawerPaper

          }}
          open={mobileOpen}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
            onBackdropClick: onMobileDrawerClick
          }}
        >
          {this.drawer(onMobileDrawerClick)}
        </Drawer>
      </Hidden></>;
  }
}

export default withTranslation(["navBar"])(NavBar);
